import { render } from "./DefaultView.vue?vue&type=template&id=65d83d88"
import script from "./DefaultView.vue?vue&type=script&lang=js"
export * from "./DefaultView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/DefaultView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65d83d88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65d83d88', __exports__)) {
    api.reload('65d83d88', __exports__)
  }
  
  module.hot.accept("./DefaultView.vue?vue&type=template&id=65d83d88", () => {
    api.rerender('65d83d88', render)
  })

}


export default __exports__